import { startOfToday } from "date-fns";
import {
  convertHtmlToText,
  sortCategoryOptionsByType,
} from "@/utils/helpers.js";
import {
  disputeOutcomesIncorrectPayer,
  disputeRootCauseIncorrectPayer,
  disputeCategoryIncorrectPayer,
  disputeLanguageList,
  MANUAL_SURCHARGE_AUTO_RESOLUTION_ALGO_NAME,
  AUTO_RESOLUTION_OUTCOME_POTENTIAL_REJECT,
} from "@/config/constant.js";
import { creditNoteFailureList } from "./constant";

export const updateDisputeDropDownList = [
  {
    id: 1,
    displayName: "Options",
    label: "Options",
    value: "Options",
    disabled: true,
  },
  {
    id: 2,
    displayName: "Update assignee",
    label: "Update assignee",
    value: "Update_assignee",
  },
  {
    id: 3,
    displayName: "Update tender",
    label: "Update tender",
    value: "Update_tender",
  },
  {
    id: 5,
    displayName: "Update case details",
    label: "Update case details",
    value: "Update_casedetails",
  },
  {
    id: 6,
    displayName: "Update contact details",
    label: "Update contact details",
    value: "Update_contact_details",
  },
  {
    id: 7,
    displayName: "Update voice (DwV)",
    label: "Update voice (DwV)",
    value: "Update_voice",
  },
];

export const booleanRadioFields = [
  {
    id: 0,
    label: "Yes",
    value: true,
  },
  {
    id: 1,
    label: "No",
    value: false,
  },
];

export const contingencyReasonOptions = [
  {
    id: "N/A",
    label: "N/A",
    value: "N/A",
  },
  {
    id: "Strait of Hormuz",
    label: "Strait of Hormuz",
    value: "Strait of Hormuz",
  },
];

export const straitOfHormuzAllowedChargeCodes = ["LPF", "ERS"];

export const straitOfHormuzChangeAllowedChargeCodes = ["ECS", "PSS"];

// Reason codes for which the charge-code-to-invoice-charge validation should be skipped
export const chargeCodeValidationSkipReasonCodes = ["0002", "0010"];

const reviewDecisionOptions = [
  {
    id: "Select",
    label: "Select",
    value: "",
  },
  {
    id: "Accept",
    label: "Accept",
    value: "Accept",
  },
  {
    id: "Reject",
    label: "Reject",
    value: "Reject",
  },
  {
    id: "Out of scope",
    label: "Out of scope",
    value: "Out of scope",
  },
];

// Reason options keyed by reviewDecision value
const reviewReasonOptionsMap = {
  Accept: [
    {
      id: "Select",
      label: "Select",
      value: "",
    },
    {
      id: "System updated incorrectly hence the automation rejected the charge",
      label:
        "System updated incorrectly hence the automation rejected the charge",
      value:
        "System updated incorrectly hence the automation rejected the charge",
    },
    {
      id: "Email found in case management which is clear evidence that the customer must not be charged",
      label:
        "Email found in case management which is clear evidence that the customer must not be charged",
      value:
        "Email found in case management which is clear evidence that the customer must not be charged",
    },
    {
      id: "ISR Raised for the specific charge which is approver hence accepting the charge",
      label:
        "ISR Raised for the specific charge which is approver hence accepting the charge",
      value:
        "ISR Raised for the specific charge which is approver hence accepting the charge",
    },
  ],
  Reject: [
    {
      id: "Select",
      label: "Select",
      value: "",
    },
    {
      id: "was the rejection template used AS IS",
      label: "was the rejection template used AS IS",
      value: "was the rejection template used AS IS",
    },
    {
      id: "was the template used AS IS but added a detail to match customer email",
      label:
        "was the template used AS IS but added a detail to match customer email",
      value:
        "was the template used AS IS but added a detail to match customer email",
    },
    {
      id: "was the template used AS IS but added a detail to match customer email which required investigation",
      label:
        "was the template used AS IS but added a detail to match customer email which required investigation",
      value:
        "was the template used AS IS but added a detail to match customer email which required investigation",
    },
  ],
  "Out of scope": [
    {
      id: "Select",
      label: "Select",
      value: "",
    },
    {
      id: "Payer dispute",
      label: "Payer dispute",
      value: "Payer dispute",
    },
    {
      id: "Already Paid",
      label: "Already Paid",
      value: "Already Paid",
    },
    {
      id: "Currency/ROE issue",
      label: "Currency/ROE issue",
      value: "Currency/ROE issue",
    },
    {
      id: "Commercial",
      label: "Commercial",
      value: "Commercial",
    },
    {
      id: "Others",
      label: "Others",
      value: "Others",
    },
  ],
};

// SubReason only shown when reviewReason is "was the rejection template used AS IS"
const reviewSubReasonOptions = [
  {
    id: "Select",
    label: "Select",
    value: "",
  },
  {
    id: "Customer aligned",
    label: "Customer aligned",
    value: "Customer aligned",
  },
  {
    id: "Further investigation required",
    label: "Further investigation required",
    value: "Further investigation required",
  },
];

export const updateTenderFormFields = () => [
  {
    title: "",
    formStyle: {
      border: "none",
      padding: 0,
      "margin-bottom": 0,
    },
    fieldStyle: {
      flex: "0 100%",
    },
    formFields: [
      {
        id: "isTender",
        label: "Is Tender",
        type: "radio",
        name: "isTender",
        required: true,
        radioOptions: booleanRadioFields.map((item) => ({
          ...item,
          name: "isTender",
        })),
        validation: {
          rules: ["required"],
        },
      },
      {
        id: "comments",
        label: "Comments",
        placeholder: "Enter your comments here...",
        type: "textbox",
        name: "comments",
        style: {
          flex: "0 100%",
        },
        maxLength: 4000,
        validation: {
          customValidation: (value) => ({
            isError:
              value && convertHtmlToText(value).length > 4000 ? true : false,
            errorMessage: `Summary supports maximum 4000 characters.`,
          }),
        },
      },
    ],
  },
];

export const contactDetailsModalInputFields = (caseDetails) => [
  {
    title: "",
    formStyle: {
      border: "none",
      padding: 0,
      "margin-bottom": 0,
    },
    fieldStyle: {
      flex: "0 100%",
    },
    formFields: [
      {
        id: "contactPerson",
        label: "Contact Name",
        placeholder: "Provide Contact Name",
        type: "input",
        name: "contactPerson",
        required: true,
        defaultValue: caseDetails?.contactPerson,
        validation: {
          rules: ["required"],
        },
      },
      {
        id: "contactEmail",
        label: "Contact Email",
        placeholder: "Provide Contact email",
        type: "input",
        name: "contactEmail",
        required: true,
        defaultValue: caseDetails?.contactEmail,
        validation: {
          rules: ["email", "required"],
        },
      },
      {
        id: 2,
        label: "Contact Number",
        placeholder: "Provide Contact number",
        type: "input",
        name: "contactTelNumber",
        defaultValue: caseDetails?.contactTelNumber,
        style: {
          "padding-bottom": 0,
        },
      },
    ],
  },
];

export const statusCodesToEnableDwV = [
  "30",
  "66",
  "67",
  "71",
  "72",
  "73",
  "74",
  "75",
  "79",
];

export const disputeStatusToEnableDwV = ["Reject with voice", "Close"];

export const voiceDisputeUpdateForm = (disputesConstants, disputeAgent) => {
  try {
    return [
      {
        id: 1,
        title: "Contact Information",
        formFields: [
          {
            id: "contactPerson",
            label: "Contact Name",
            placeholder: "Provide Contact Name",
            type: "input",
            name: "contactPerson",
            required: true,
            errorMessage: "Contact name is required",
            disabled: (formState) => (formState?.contactPerson ? true : false),
            validation: {
              rules: ["required", "name"],
            },
          },
          {
            id: "contactEmail",
            label: "Contact Email",
            placeholder: "Provide Contact email",
            type: "input",
            name: "contactEmail",
            required: true,
            errorMessage: "Contact email is required",
            disabled: (formState) => (formState.contactEmail ? true : false),
            validation: {
              rules: ["required", "email"],
            },
          },
          {
            id: "contactTelNumber",
            label: "Contact Number",
            placeholder: "Provide Contact number",
            type: "input",
            name: "contactTelNumber",
          },
          {
            id: "ohpDisputeVoiceAgent",
            label: "Dispute Voice Agent",
            placeholder: "Search dispute agent name",
            type: "searchDropdown",
            dropdownLabel: "value",
            options: disputeAgent || [],
            required: true,
            loading: false,
            name: "ohpDisputeVoiceAgent",
            validation: {
              rules: ["required"],
            },
          },
        ],
      },
      {
        id: 2,
        title: "Call Information",
        formFields: [
          {
            id: "contactType",
            label: "Contact Mode",
            type: "radio",
            name: "contactType",
            radioOptions: [
              {
                id: "EMAIL",
                label: "Email",
                name: "contactType",
                value: "EMAIL",
                checked: false,
              },
              {
                id: "PHONE",
                label: "Phone",
                name: "contactType",
                value: "PHONE",
                checked: false,
              },
            ],
            required: true,
            errorMessage: "Contact mode is required!",
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "isAttemptSuccessful",
            label: "Attempt Successful?",
            type: "radio",
            name: "isAttemptSuccessful",
            radioOptions: booleanRadioFields.map((item) => ({
              ...item,
              name: "isAttemptSuccessful",
            })),
            required: true,
            errorMessage: "Attempt status is required!",
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "nextActionDate",
            label: "Next Action Date",
            placeholder: "dd/mm/yyyy",
            type: "date",
            name: "nextActionDate",
            minDate: startOfToday(),
          },
          {
            id: "voiceOutcome",
            label: "DWV Outcome",
            placeholder: "Select an option",
            type: "select",
            name: "voiceOutcome",
            options: disputesConstants?.DISPUTE_VOICE_OUTCOME,
            required: true,
            errorMessage: "DWV Outcome is required!",
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "voiceSummary",
            label: "Summary",
            placeholder: "Enter your comments here...",
            type: "textbox",
            name: "voiceSummary",
            required: true,
            style: {
              flex: "0 100%",
            },
            maxLength: 1024,
            validation: {
              rules: ["required"],
              customValidation: (value) => ({
                isError:
                  value &&
                  value != "" &&
                  value != null &&
                  (convertHtmlToText(value).length > 1024 ||
                    convertHtmlToText(value).length < 1)
                    ? true
                    : false,
                errorMessage: `Summary supports maximum 1024 characters.`,
              }),
            },
          },
          {
            id: 5,
            label: "Payment Information",
            type: "title",
            style: {
              flex: "0 100%",
            },
          },
          {
            id: "invoiceClearedDate",
            label: "Invoice Cleared Date",
            placeholder: "dd/mm/yyyy",
            type: "date",
            name: "invoiceClearedDate",
          },
          {
            id: "isCustomerAligned",
            label: "Is Customer Aligned?",
            type: "radio",
            name: "isCustomerAligned",
            radioOptions: booleanRadioFields.map((item) => ({
              ...item,
              name: "isCustomerAligned",
            })),
            errorMessage: "This field is required!",
            required: true,
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "isP2PAgreed",
            label: "Promise to Pay",
            type: "radio",
            name: "isP2PAgreed",
            radioOptions: booleanRadioFields.map((item) => ({
              ...item,
              name: "isP2PAgreed",
            })),
            visible: (formState) => formState?.isCustomerAligned,
          },
          {
            id: "expectedP2pDate",
            label: "P2P Date",
            type: "date",
            placeholder: "dd/mm/yyyy",
            name: "expectedP2pDate",
            visible: (formState) => formState?.isCustomerAligned,
            disabled: () => false,
          },
          {
            id: "p2pAmountUsd",
            label: "P2P Amount (USD)",
            placeholder: "Enter amount here...",
            type: "input",
            name: "p2pAmountUsd",
            visible: (formState) => formState?.isCustomerAligned,
          },
        ],
      },
    ];
  } catch (err) {
    console.log(err);
  }
};

export const voiceDisputeTableMoreOptions = [
  {
    displayName: "Edit voice dispute (DwV)",
    id: "edit",
    icon: "",
  },
  {
    displayName: "View edit history",
    id: "edit_history",
    icon: "",
  },
];

const checkForRequiredRule = (formMandatoryList, key) => {
  if ((formMandatoryList || []).includes(key)) {
    return ["required"];
  }
  return [];
};

const isAlphanumeric = (str) => {
  return str.search(/^[a-zA-Z0-9]+$/) === -1;
};

const isCreditNoteValidation = (str) => {
  return (
    str.search(/^[A-Z]{2}\d{2}[A-Z]{2}\d{10}$/) === -1 &&
    str.length !== 10 &&
    str.length !== 0
  );
};

export const disputeCaseDetailsForm = (
  disputesConstants,
  resolutionStagesList,
  resolutionStatusList,
  disputeLookupFields,
  disputeChargecodeFields,
  formDisabledList,
  formMandatoryList,
  searchLoader,
  processorList,
  nextStatusDropDownList,
  onStageDropdownChange,
  caseDetails,
  isPotentialReject,
  tier2OptionList,
  isBulk,
  isSLAMissed,
  reasonForDelayOptionsList,
  isIncorrectPayer,
  showCreditNote,
  showIncident,
  invoiceCreditNote,
  isChargeCodeMandatoryForInProcess = false,
  isContingencyReasonMandatory = false,
  isContingencyReasonLocked = false,
  isContingencyReasonDisabled = false,
  reviewDecisionValue = null,
  reviewReasonValue = null,
  reviewJustificationValue = null
) => {
  caseDetails = { ...caseDetails, isInAutoResolution: false };
  const referenceKeyValue = (
    caseDetails?.referenceKey ||
    caseDetails?.reference_key ||
    caseDetails?.referenceType ||
    ""
  )
    .toString()
    .trim()
    .toUpperCase();
  //const showFeedBackForm = !isBulk && referenceKeyValue === "DEM-INV";
  const showFeedBackForm =
    caseDetails?.autoResolutionAlgoName ===
      MANUAL_SURCHARGE_AUTO_RESOLUTION_ALGO_NAME &&
    caseDetails?.autoResolutionOutcome ===
      AUTO_RESOLUTION_OUTCOME_POTENTIAL_REJECT &&
    caseDetails?.disputeStage !== "Close";
  console.log(
    "showFeedBackForm",
    showFeedBackForm,
    caseDetails?.autoResolutionAlgoName,
    caseDetails?.autoResolutionOutcome,
    caseDetails
  );
  const isReviewJustificationMandatory =
    showFeedBackForm &&
    !(
      reviewDecisionValue === "Out of scope" && reviewReasonValue !== "Others"
    ) &&
    reviewDecisionValue !== "Reject";
  try {
    return [
      {
        id: 1,
        fieldStyle: {
          "min-width": "400px",
        },
        formFields: [
          {
            id: "disputeStage",
            label: "Dispute stage",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "disputeStage",
            options: resolutionStagesList,
            required: true,
            disabled: () =>
              (formDisabledList || []).includes("disputeStage") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "statusCode",
            label: "Dispute status",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "statusCode",
            options: resolutionStatusList,
            required: true,
            disabled: () =>
              caseDetails?.isInAutoResolution
                ? true
                : !onStageDropdownChange
                ? (formDisabledList || []).includes("statusCode")
                : nextStatusDropDownList && !nextStatusDropDownList.length
                ? true
                : false,
            validation: {
              rules: ["required"],
            },
          },
          {
            id: "rootCauseCode",
            label: "Rootcause",
            placeholder: "Select an option",
            type: "searchDropdown",
            name: "rootCauseCode",
            dropdownLabel: "value",
            options: isIncorrectPayer
              ? disputeRootCauseIncorrectPayer
              : disputeLookupFields?.ROOT_CAUSE,
            required: (formMandatoryList || []).includes("rootCauseCode"),
            disabled: () =>
              (formDisabledList || []).includes("rootCauseCode") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "rootCauseCode"),
            },
            optionName: "ROOT_CAUSE",
            loading: searchLoader["ROOT_CAUSE"],
            clearable: true,
          },
          {
            id: "disputeOutcomeCode",
            label: "Outcome",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "disputeOutcomeCode",
            options: isIncorrectPayer
              ? disputeOutcomesIncorrectPayer
              : disputesConstants?.OUTCOME,
            required: (formMandatoryList || []).includes("disputeOutcomeCode"),
            disabled: () =>
              (formDisabledList || []).includes("disputeOutcomeCode") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(
                formMandatoryList,
                "disputeOutcomeCode"
              ),
            },
          },
          {
            id: "categoryCode",
            label: "Category",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "categoryCode",
            options: isIncorrectPayer
              ? disputeCategoryIncorrectPayer
              : sortCategoryOptionsByType(disputesConstants?.CATEGORY),
            required: (formMandatoryList || []).includes("categoryCode"),
            disabled: () =>
              (formDisabledList || []).includes("categoryCode") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "categoryCode"),
            },
          },
          {
            id: "reasonCode",
            label: "Dispute reason",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "reasonCode",
            options: disputesConstants?.REASON,
            required: (formMandatoryList || []).includes("reasonCode"),
            disabled: () =>
              (formDisabledList || []).includes("reasonCode") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "reasonCode"),
            },
          },
          {
            id: "chargeCode",
            label: "Charge code",
            type: "searchDropdown",
            dropdownLabel: "value",
            name: "chargeCode",
            placeholder: "Select charge code",
            multiple: true,
            required:
              (formMandatoryList || []).includes("chargeCode") ||
              isChargeCodeMandatoryForInProcess,
            disabled: () =>
              (formDisabledList || []).includes("chargeCode") ||
              caseDetails?.isInAutoResolution,
            options: disputeChargecodeFields?.CHARGE_CODE,
            validation: {
              rules:
                (formMandatoryList || []).includes("chargeCode") ||
                isChargeCodeMandatoryForInProcess
                  ? ["required"]
                  : [],
            },
            optionName: "CHARGE_CODE",
            loading: searchLoader["CHARGE_CODE"],
          },
          {
            id: "contingencyReason",
            label: "Contingency reason",
            placeholder: "Select an option",
            type: "searchDropdown",
            name: "contingencyReason",
            dropdownLabel: "value",
            options: contingencyReasonOptions,
            required: isContingencyReasonMandatory,
            disabled: () =>
              (formDisabledList || []).includes("contingencyReason") ||
              caseDetails?.isInAutoResolution ||
              isContingencyReasonLocked ||
              isContingencyReasonDisabled,
            validation: {
              rules: isContingencyReasonMandatory ? ["required"] : [],
            },
            clearable: true,
          },
          {
            id: "coordinatorCode",
            label: "Coordinator",
            placeholder: "Select an option",
            type: isPotentialReject ? "select" : "searchDropdown",
            name: "coordinatorCode",
            stateValue: isPotentialReject ? "optionObject" : "",
            dropdownLabel: "value",
            options: isPotentialReject
              ? tier2OptionList
              : disputeLookupFields?.COORDINATOR,
            required: (formMandatoryList || []).includes("coordinatorCode"),
            disabled: () =>
              (formDisabledList || []).includes("coordinatorCode") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "coordinatorCode"),
            },
            optionName: "COORDINATOR",
            loading: searchLoader["COORDINATOR"],
            clearable: true,
          },
          {
            id: "contractCorrection",
            label: "Contract correction",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "contractCorrection",
            options: disputesConstants?.CONTRACT_CORRECTION,
            required: (formMandatoryList || []).includes("contractCorrection"),
            disabled: () =>
              (formDisabledList || []).includes("contractCorrection") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(
                formMandatoryList,
                "contractCorrection"
              ),
            },
          },
          {
            id: "invoiceAmount",
            label: "Invoice amount",
            type: "input",
            name: "invoiceAmount",
            placeholder: "Enter Invoice amount",
            inputType: "number",
            required: (formMandatoryList || []).includes("invoiceAmount"),
            disabled: () =>
              (formDisabledList || []).includes("invoiceAmount") || true,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "invoiceAmount"),
              customValidation: (value, field) => ({
                isError: value && isNaN(value) ? true : false,
                errorMessage: `${field.label} should be a number`,
              }),
            },
          },
          {
            id: "processorName",
            label: "Processor name",
            type: "searchDropdown",
            dropdownLabel: "value",
            name: "processorName",
            placeholder: "Select a user to assign as processor",
            required: (formMandatoryList || []).includes("processorName"),
            disabled: () =>
              (formDisabledList || []).includes("processorName") ||
              caseDetails?.isInAutoResolution,
            options: processorList,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "processorName"),
            },
            optionName: "PROCESSOR_NAME",
            loading: searchLoader["PROCESSOR_NAME"],
            clearable: true,
          },
          {
            id: "expectedAmount",
            label: "Expected amount",
            type: "input",
            name: "expectedAmount",
            inputType: "number",
            placeholder: "Enter expected Amount",
            required: (formMandatoryList || []).includes("expectedAmount"),
            disabled: () =>
              (formDisabledList || []).includes("expectedAmount") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "expectedAmount"),
              customValidation: (value, field) => ({
                isError: value && isNaN(value) ? true : false,
                errorMessage: `${field.label} should be a number`,
              }),
            },
          },
          {
            id: "noOfContainers",
            label: "No of containers",
            type: "input",
            name: "noOfContainers",
            inputType: "number",
            placeholder: "Enter No of containers",
            required: (formMandatoryList || []).includes("noOfContainers"),
            disabled: () =>
              (formDisabledList || []).includes("noOfContainers") ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "noOfContainers"),
              customValidation: (value, field) => ({
                isError: value && isNaN(value) ? true : false,
                errorMessage: `${field.label} should be a number`,
              }),
            },
          },
          {
            id: "currency",
            label: "Currency",
            type: "searchDropdown",
            dropdownLabel: "value",
            name: "currency",
            placeholder: "Select Currency",
            required: (formMandatoryList || []).includes("currency"),
            disabled: () =>
              (formDisabledList || []).includes("currency") || true,
            options: disputeLookupFields?.CURRENCY,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "currency"),
            },
            optionName: "CURRENCY",
            loading: searchLoader["CURRENCY"],
            clearable: true,
          },
          {
            id: "redisputeCategory",
            label: "Redispute category",
            type: "select",
            name: "redisputeCategory",
            placeholder: "Select an option",
            visible: () => caseDetails?.isRedisputed || false,
            required: (formMandatoryList || []).includes("redisputeCategory"),
            disabled: () =>
              (formDisabledList || []).includes("redisputeCategory") ||
              caseDetails?.isInAutoResolution,
            options: isIncorrectPayer
              ? disputeCategoryIncorrectPayer
              : sortCategoryOptionsByType(disputesConstants?.CATEGORY),
            stateValue: "optionObject",
            validation: {
              rules: checkForRequiredRule(
                formMandatoryList,
                "redisputeCategory"
              ),
            },
          },
          {
            id: "redisputeOutcomeCode",
            label: "Redispute outcome",
            type: "select",
            name: "redisputeOutcomeCode",
            placeholder: "Select an option",
            visible: () => caseDetails?.isRedisputed || false,
            required: (formMandatoryList || []).includes(
              "redisputeOutcomeCode"
            ),
            disabled: () =>
              (formDisabledList || []).includes("redisputeOutcomeCode") ||
              caseDetails?.isInAutoResolution,
            options: isIncorrectPayer
              ? disputeOutcomesIncorrectPayer
              : disputesConstants?.OUTCOME,
            stateValue: "optionObject",
            validation: {
              rules: checkForRequiredRule(
                formMandatoryList,
                "redisputeOutcomeCode"
              ),
            },
          },
          {
            id: "redisputeRootCauseCode",
            label: "Redispute rootcause",
            type: "searchDropdown",
            dropdownLabel: "value",
            name: "redisputeRootCauseCode",
            placeholder: "Select an option",
            visible: () => caseDetails?.isRedisputed || false,
            required: (formMandatoryList || []).includes(
              "redisputeRootCauseCode"
            ),
            disabled: () =>
              (formDisabledList || []).includes("redisputeRootCauseCode") ||
              caseDetails?.isInAutoResolution,
            options: isIncorrectPayer
              ? disputeRootCauseIncorrectPayer
              : disputeLookupFields?.ROOT_CAUSE,
            validation: {
              rules: checkForRequiredRule(
                formMandatoryList,
                "redisputeRootCauseCode"
              ),
            },
            optionName: "RE_DISPUTE_ROOT_CAUSE",
            loading: searchLoader["RE_DISPUTE_ROOT_CAUSE"],
            clearable: true,
          },
          {
            id: "isCreditNoteManual",
            label: "Is credit note updated manually?",
            type: "switch",
            name: "isCreditNoteManual",
            // disabled: () => (showCreditNote ? false : true),
            disabled: () => true,
            // helpMessage:
            //   "Comments are internal by default, to make it visible to customers toggle this button.",
            visible: () => showCreditNote && isBulk == false,
          },
          {
            id: "creditNote",
            label: "Credit Note",
            type: "input",
            name: "creditNote",
            inputType: "text",
            placeholder: "Enter Credit Note",
            required: true,
            validation: {
              rules: showCreditNote ? "required" : "",
              customValidation: (value, field) => ({
                isError: value && isCreditNoteValidation(value) ? true : false,
                errorMessage: `${field.label} should be a valid credit note number`,
              }),
            },
            disabled: () =>
              invoiceCreditNote != "" && invoiceCreditNote != undefined
                ? true
                : false,
            visible: () => (showCreditNote ? true : false) && isBulk == false,
          },
          {
            id: "failureReason",
            label: "Credit Note Failure Reason",
            type: "searchDropdown",
            dropdownLabel: "value",
            name: "failureReason",
            placeholder: "Select a reason",
            required: true,
            disabled: () => (formDisabledList || []).includes("failureReason"),
            options: creditNoteFailureList || [],
            validation: {
              rules:
                showCreditNote &&
                (invoiceCreditNote == "" || invoiceCreditNote == undefined)
                  ? "required"
                  : "",
            },
            // optionName: "CREDIT_NOTE_FAILURE_REASON",
            loading: searchLoader["CREDIT_NOTE_FAILURE_REASON"],
            clearable: true,
            visible: () =>
              (showCreditNote ? true : false) &&
              isBulk == false &&
              (invoiceCreditNote == "" || invoiceCreditNote == undefined
                ? true
                : false),
          },
          {
            id: "incidentId",
            label: "Incident Number",
            type: "input",
            name: "incidentId",
            inputType: "text",
            placeholder: "Enter Incident Number",
            required: false,
            // disabled: () =>
            //   (formDisabledList || []).includes("incidentId") ||
            //   caseDetails?.isInAutoResolution,
            // validation: {
            //   rules: checkForRequiredRule(formMandatoryList, "incidentId"),
            //   customValidation: (value, field) => ({
            //     isError: value && isAlphanumeric(value) ? true : false,
            //     errorMessage: `${field.label} should be a number or alphabets`,
            //   }),
            // },
            visible: () => (showIncident ? true : false) && isBulk == false,
          },
          {
            id: "isExternalComment",
            label: "Is external comment",
            type: "switch",
            name: "isExternalComment",
            disabled: () => caseDetails?.isInAutoResolution,
            helpMessage:
              "Comments are internal by default, to make it visible to customers toggle this button.",
          },
          // {
          //   id: "isNotifyCommentDescription",
          //   label: "Is Notification Enabled",
          //   type: "switch",
          //   name: "isNotifyCommentDescription",
          //   disabled: () => caseDetails?.isInAutoResolution,
          //   helpMessage:
          //     "To email below comment to customers toggle this button, by default its off.",
          //   visible: () =>
          //     (formDisabledList || []).indexOf("isNotifyCommentDescription") ===
          //       -1 &&
          //     caseDetails?.createdSource !== "MYFINANCE" &&
          //     !isBulk,
          // },
          {
            id: "isRephraseButton",
            label: "Tweak Comments With Atom Intelligence",
            type: "switch",
            name: "rephraseSentence",
            helpMessage:
              "Toggle this button to effortlessly rephrase your comments for clearer and concise communication",
            disabled: (formState) => formState?.rephraseSentence,
            visible: (formState) =>
              (formState?.noteDescription && formState?.isExternalComment) ??
              "",
          },
          {
            id: "languageList",
            label: "Target Language",
            placeholder: "Select a Language",
            type: "select",
            options: disputeLanguageList,
            name: "languageList",
            visible: (formState) =>
              (formState?.noteDescription && formState?.isExternalComment) ??
              "",
          },
          {
            id: "resolutionDelayReason",
            label: "Reason for delay in resolution",
            placeholder: "Select an reason",
            type: "select",
            name: "resolutionDelayReason",
            options: reasonForDelayOptionsList,
            required: true,
            stateValue: "optionObject",
            errorMessage: "Reson for delay is required",
            disabled: (formState) =>
              caseDetails?.isInAutoResolution ||
              (!isBulk &&
                !!caseDetails?.resolutionDelayReason &&
                formState.disputeStage?.value !== "Reject"),
            visible: (formState) =>
              ((formDisabledList || []).indexOf("reasonForDelayOptions") ===
                -1 ||
                coordinatorToCaptureDelayReason.indexOf(
                  formState?.coordinatorCode?.id
                ) !== -1) &&
              isSLAMissed,
            validation: {
              customValidation: (value, field, formState) => ({
                isError:
                  (coordinatorToCaptureDelayReason.indexOf(
                    formState?.coordinatorCode?.id
                  ) !== -1 ||
                    (formDisabledList || []).indexOf(
                      "reasonForDelayOptions"
                    ) === -1) &&
                  !value &&
                  isSLAMissed
                    ? true
                    : false,
                errorMessage: `Reson for delay is required as SLA is missed for ${
                  isBulk
                    ? "at least one of the selected cases"
                    : "selected case"
                }`,
              }),
            },
          },
          {
            id: "rephrasedText",
            label: "Rephrased Text",
            type: "input",
            name: "rephrasedText",
            helpMessage:
              "Your original text, expertly tweaked with AI for better readability and coherence",
            visible: (formState) =>
              (formState?.noteDescription && formState?.isExternalComment) ??
              "",
          },
          {
            id: "noteDescription",
            label: (formState) =>
              `Comments (will be persisted on FSCM ${
                formState.isExternalComment ? "& visible to customers" : ""
              })`,
            type: "textbox",
            name: "noteDescription",
            style: {
              flex: "0 100%",
            },
            placeholder: "Enter your comments",
            required: (formMandatoryList || []).includes("noteDescription"),
            disabled: () =>
              (formDisabledList || []).includes("noteDescription") ||
              caseDetails?.isInAutoResolution,
            maxLength: 4000,
            validation: {
              rules: checkForRequiredRule(formMandatoryList, "noteDescription"),
              customValidation: (value) => ({
                isError:
                  value && convertHtmlToText(value).length > 4000
                    ? true
                    : false,
                errorMessage: `Comments supports maximum 4000 characters.`,
              }),
            },
          },
          {
            id: "feedbackFormTitle",
            label: "Feedback Input",
            type: "title",
            style: {
              flex: "0 100%",
              background: "#42b0d5",
              padding: "8px 12px",
              //"border-left": "4px solid #1a5276",
              "border-radius": "2px",
              "font-weight": "600",
              "margin-bottom": "12px",
            },
            visible: () => showFeedBackForm,
          },
          {
            id: "reviewDecision",
            label: "Review Decision",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "reviewDecision",
            options: reviewDecisionOptions,
            required: showFeedBackForm,
            visible: () => showFeedBackForm,
            disabled: () => caseDetails?.isInAutoResolution,
            validation: {
              rules: showFeedBackForm ? ["required"] : [],
            },
          },
          {
            id: "reviewReason",
            label: "Review Reason",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "reviewReason",
            options: reviewReasonOptionsMap[reviewDecisionValue] || [],
            required: !!reviewDecisionValue && !caseDetails?.isInAutoResolution,
            visible: () => showFeedBackForm,
            disabled: () =>
              !reviewDecisionValue || caseDetails?.isInAutoResolution,
            validation: {
              rules:
                !!reviewDecisionValue && !caseDetails?.isInAutoResolution
                  ? ["required"]
                  : [],
            },
          },
          {
            id: "reviewSubReason",
            label: "Review Sub Reason",
            placeholder: "Select an option",
            type: "select",
            stateValue: "optionObject",
            name: "reviewSubReason",
            options: reviewSubReasonOptions,
            required:
              reviewReasonValue === "was the rejection template used AS IS" &&
              !caseDetails?.isInAutoResolution,
            visible: () => showFeedBackForm,
            disabled: () =>
              reviewReasonValue !== "was the rejection template used AS IS" ||
              caseDetails?.isInAutoResolution,
            validation: {
              rules:
                reviewReasonValue === "was the rejection template used AS IS" &&
                !caseDetails?.isInAutoResolution
                  ? ["required"]
                  : [],
            },
          },
          {
            id: "reviewJustification",
            label: "Comments / Justification",
            placeholder: "Enter comments...",
            type: "textbox",
            name: "reviewJustification",
            style: {
              flex: "0 100%",
            },
            required: true,
            validation: {
              rules: showFeedBackForm ? ["required"] : [],
              customValidation: (value) => ({
                isError:
                  showFeedBackForm &&
                  value &&
                  value !== "" &&
                  value !== null &&
                  convertHtmlToText(value).length < 1
                    ? true
                    : false,
                errorMessage: "Comments / Justification is required",
              }),
            },
            visible: () => showFeedBackForm,
            disabled: () => caseDetails?.isInAutoResolution,
          },
        ],
      },
    ];
  } catch (err) {
    console.log(err);
  }
};
export const disputeBulkAlertMessage = {
  title: "Please fulfill the following conditions for bulk update -",
  messageList: [
    {
      id: 1,
      title: "Workflow",
      value: "Please select cases with the same Dispute Stage",
    },
    {
      id: 2,
      title: "Resolution",
      value: "Please select cases with the same Dispute Status & Dispute Stage",
    },
    {
      id: 3,
      title: "Dispute with Voice",
      value:
        "Please select cases with same Customer Contact Name & Contact Email",
    },
  ],
};

export const redisputeAlertMessage = {
  title: "Dispute Case update is in progress... Please try after sometime",
};

export const bulkUpdateAlertMessageOnTimeout = {
  title:
    "Dispute Case update is in progress... Please check the dispute status after few minutes.",
};

export const disputeStageMapping = {
  20: "In-Process",
  60: "Accept",
  61: "Accept",
  62: "Accept",
  63: "Accept",
  66: "Reject",
  67: "Reject",
  71: "Reject",
  72: "Reject",
  73: "Reject",
  74: "Reject",
  78: "Reject",
  30: "Reject with voice",
  10: "New",
  75: "New",
};

export const resolutionModalSteps = {
  case_details_form: {
    name: "case_details_form",
    title: "Update case detail",
  },
  voice_form: {
    name: "voice_form",
    title: "Update voice (DwV)",
    showBack: true,
  },
  bulk_update_message: {
    name: "bulk_update_message",
    title: "Alert",
  },
};

export const updateCaseDetailsPayloadGenerator = (
  changedFields,
  showIncident = false,
  showFeedbackForm = false
) => ({
  disputeStage: changedFields["disputeStage"]?.value,
  creditNote: changedFields["creditNote"],
  incidentId: changedFields["incidentId"],
  //   isBulkUpdateCreditNote: changedFields["isBulkUpdateCreditNote"],
  //   isCreditNoteManual: showIncident == true ? true : false,

  statusCode: {
    statusCode: changedFields["statusCode"]?.label?.split(":")[0],
    statusDescription: changedFields["statusCode"]?.label
      ?.split(":")[1]
      ?.trim(),
  },

  rootCauseCode: {
    rootCauseCode: changedFields["rootCauseCode"]?.id,
    rootCauseDescription: changedFields["rootCauseCode"]?.label,
  },

  failureReason: {
    // failureReasonCode: changedFields["failureReason"]?.id,
    failureReason: changedFields["failureReason"]?.label,
  },

  disputeOutcomeCode: {
    disputeOutcomeCode: changedFields["disputeOutcomeCode"]?.id,
    disputeOutcomeDescription: changedFields["disputeOutcomeCode"]?.value,
  },

  categoryCode: {
    categoryCode: changedFields["categoryCode"]?.id,
    categoryDescription: changedFields["categoryCode"]?.value,
  },

  reasonCode: {
    reasonCode: changedFields["reasonCode"]?.id,
    reasonDescription: changedFields["reasonCode"]?.value,
  },

  contingencyReason: changedFields["contingencyReason"]?.value,

  coordinatorCode: {
    coordinatorCode: changedFields["coordinatorCode"]?.id,
    coordinatorFunction: changedFields["coordinatorCode"]?.label,
  },

  contractCorrection: changedFields["contractCorrection"]?.value,

  invoiceAmount: changedFields["invoiceAmount"]
    ? parseFloat(changedFields["invoiceAmount"])
    : null,

  processorName: changedFields["processorName"]?.apmId,
  processorFullName: changedFields["processorName"]?.userName,

  expectedAmount: changedFields["expectedAmount"]
    ? parseFloat(changedFields["expectedAmount"])
    : null,

  noOfContainers: changedFields["noOfContainers"]
    ? parseFloat(changedFields["noOfContainers"])
    : null,

  currency: changedFields["currency"]?.value,

  chargeCode: {
    chargeCode: (changedFields["chargeCode"] || [])
      .map((item) => item?.id || item)
      .join("+"),
    chargeCodeValue: (changedFields["chargeCode"] || [])
      .map((item) => (item?.id || item).split("-")[0])
      .join("+"),
  },

  redisputeCategory: {
    redisputeCategory: changedFields["redisputeCategory"]?.id,
    redisputeCategoryDescription: changedFields["redisputeCategory"]?.value,
  },

  redisputeOutcomeCode: {
    redisputeOutcomeCode: changedFields["redisputeOutcomeCode"]?.id,
    redisputeOutcomeDescription: changedFields["redisputeOutcomeCode"]?.value,
  },

  redisputeRootCauseCode: {
    redisputeRootCauseCode: changedFields["redisputeRootCauseCode"]?.id,
    redisputeRootCauseDescription:
      changedFields["redisputeRootCauseCode"]?.label,
  },

  // isNotifyCommentDescription: changedFields["isNotifyCommentDescription"],

  noteDescription: changedFields["noteDescription"],

  ...(showFeedbackForm && {
    disputeResolutionFeedback: {
      reviewDecision: changedFields["reviewDecision"]?.value,
      reviewReason: changedFields["reviewReason"]?.value,
      reviewSubReason: changedFields["reviewSubReason"]?.value,
      reviewJustification: changedFields["reviewJustification"]
        ? convertHtmlToText(changedFields["reviewJustification"])
        : null,
    },
  }),
  resolutionDelayReason: changedFields["resolutionDelayReason"]?.value,
});

export const reasonForDelayOptions = [
  {
    id: "select",
    label: "Select",
    value: "",
  },
  {
    id: "Amendment Team-Process waiver",
    label: "Amendment Team-Process waiver",
    value: "Amendment Team-Process waiver",
  },
  {
    id: "Area CX-Delay in ISR Response",
    label: "Area CX-Delay in ISR Response",
    value: "Area CX-Delay in ISR Response",
  },
  {
    id: "Area Sales-Delay in ISR/Email resolution",
    label: "Area Sales-Delay in ISR/Email resolution",
    value: "Area Sales-Delay in ISR/Email resolution",
  },
  {
    id: "Area Sales-Delay in Rate filing confirmation",
    label: "Area Sales-Delay in Rate filing confirmation",
    value: "Area Sales-Delay in Rate filing confirmation",
  },
  {
    id: "Area Sales-Delay in sharing CPM/IPM/ ROPM approval",
    label: "Area Sales-Delay in sharing CPM/IPM/ ROPM approval",
    value: "Area Sales-Delay in sharing CPM/IPM/ ROPM approval",
  },
  {
    id: "Area Sales-Ongoing tender negotiation with customer",
    label: "Area Sales-Ongoing tender negotiation with customer",
    value: "Area Sales-Ongoing tender negotiation with customer",
  },
  {
    id: "Area-Approving/Raising GAM",
    label: "Area-Approving/Raising GAM",
    value: "Area-Approving/Raising GAM",
  },
  {
    id: "Customer-Delayed response",
    label: "Customer-Delayed response",
    value: "Customer-Delayed response",
  },
  {
    id: "Customer-invoice billing cycle setup",
    label: "Customer-invoice billing cycle setup",
    value: "Customer-invoice billing cycle setup",
  },
  {
    id: "Customer-PB approval",
    label: "Customer-PB approval",
    value: "Customer-PB approval",
  },
  {
    id: "Finance-LPF waiver confirmation",
    label: "Finance-LPF waiver confirmation",
    value: "Finance-LPF waiver confirmation",
  },
  {
    id: "Finance-Payment adjustment",
    label: "Finance-Payment adjustment",
    value: "Finance-Payment adjustment",
  },
  {
    id: "GSC Booking team-Error/delay while booking",
    label: "GSC Booking team-Error/delay while booking",
    value: "GSC Booking team-Error/delay while booking",
  },
  {
    id: "GSC CCT-Contract filing",
    label: "GSC CCT-Contract filing",
    value: "GSC CCT-Contract filing",
  },
  {
    id: "GSC CHM -Filing contract terms",
    label: "GSC CHM -Filing contract terms",
    value: "GSC CHM -Filing contract terms",
  },
  {
    id: "GSC Dispute-Miss out from execution",
    label: "GSC Dispute-Miss out from execution",
    value: "GSC Dispute-Miss out from execution",
  },
  {
    id: "GSC Dispute-Miss out out due to Tender landscape",
    label: "GSC Dispute-Miss out out due to Tender landscape",
    value: "GSC Dispute-Miss out out due to Tender landscape",
  },
  {
    id: "GSC DND-Filing",
    label: "GSC DND-Filing",
    value: "GSC DND-Filing",
  },
  {
    id: "GSC DND-GAM Approval",
    label: "GSC DND-GAM Approval",
    value: "GSC DND-GAM Approval",
  },
  {
    id: "GSC FMC-Delayed response for PB terms filing",
    label: "GSC FMC-Delayed response for PB terms filing",
    value: "GSC FMC-Delayed response for PB terms filing",
  },
  {
    id: "GSC Ocean-GAM Approval",
    label: "GSC Ocean-GAM Approval",
    value: "GSC Ocean-GAM Approval",
  },
  {
    id: "GSC Ocean-GAM endorsement",
    label: "GSC Ocean-GAM endorsement",
    value: "GSC Ocean-GAM endorsement",
  },
  {
    id: "GSC OTCX-Delay in ISR resolution",
    label: "GSC OTCX-Delay in ISR resolution",
    value: "GSC OTCX-Delay in ISR resolution",
  },
  {
    id: "GSC OTS- Delay in ISR response",
    label: "GSC OTS- Delay in ISR response",
    value: "GSC OTS- Delay in ISR response",
  },
  {
    id: "GSC Surcharge-Response for rate clarification",
    label: "GSC Surcharge-Response for rate clarification",
    value: "GSC Surcharge-Response for rate clarification",
  },
  {
    id: "GSC TCM-Rate Confirmation",
    label: "GSC TCM-Rate Confirmation",
    value: "GSC TCM-Rate Confirmation",
  },
  {
    id: "GSC VIP-Delayed confirmation on incorrect invoice",
    label: "GSC VIP-Delayed confirmation on incorrect invoice",
    value: "GSC VIP-Delayed confirmation on incorrect invoice",
  },
  {
    id: "Incorrect Tagging-Assigning payer to rates dispute",
    label: "Incorrect Tagging-Assigning payer to rates dispute",
    value: "Incorrect Tagging-Assigning payer to rates dispute",
  },
  {
    id: "Intermodal-Delayed ISR response on Service failure",
    label: "Intermodal-Delayed ISR response on Service failure",
    value: "Intermodal-Delayed ISR response on Service failure",
  },
  {
    id: "Operations-Delayed ISR Resolution for Rolling reason",
    label: "Operations-Delayed ISR Resolution for Rolling reason",
    value: "Operations-Delayed ISR Resolution for Rolling reason",
  },
  {
    id: "Operations-Delayed ISR Resolution on Moves Update",
    label: "Operations-Delayed ISR Resolution on Moves Update",
    value: "Operations-Delayed ISR Resolution on Moves Update",
  },
  {
    id: "Operations-Vessel Planner Confirmation",
    label: "Operations-Vessel Planner Confirmation",
    value: "Operations-Vessel Planner Confirmation",
  },
  {
    id: "Others",
    label: "Others",
    value: "Others",
  },
  {
    id: "Technical-Credit note generated but unable to close in OHP",
    label: "Technical-Credit note generated but unable to close in OHP",
    value: "Technical-Credit note generated but unable to close in OHP",
  },
  {
    id: "Technical-Credit note not generated",
    label: "Technical-Credit note not generated",
    value: "Technical-Credit note not generated",
  },
  {
    id: "Technical-OHP/S4/Salesforce technical outage",
    label: "Technical-OHP/S4/Salesforce technical outage",
    value: "Technical-OHP/S4/Salesforce technical outage",
  },
  {
    id: "Technical-Service Ticket raised",
    label: "Technical-Service Ticket raised",
    value: "Technical-Service Ticket raised",
  },
  {
    id: "Delay in closing the case in OHP by Dispute",
    label: "Delay in closing the case in OHP by Dispute",
    value: "Delay in closing the case in OHP by Dispute",
  },
];

export const coordinatorToCaptureDelayReason = [
  "GAM AB24",
  "GAM AB30",
  "GAM AB36 - D",
  "GAM AB36 - F",
  "GAM AB50",
  "GAM AB54",
  "GAM AB55",
];
export const tableActionColumns = [
  {
    title: "Checkbox",
    slotKey: "checkbox",
    width: 48,
    isFrozen: true,
    type: "checkbox",
    sortable: true,
  },
];
